import BlogHero from "../components/blog/BlogHero";
import BlogList from "../components/blog/BlogList";
import { useSeo } from "../utils/useSeo";

export default function News() {
  useSeo({
    title: "News",
    description: "The latest Brown Esports news, events, and announcements.",
  });
  return (
    <div className="relative bg-gray-900">
      <BlogHero />
      <BlogList />
    </div>
  );
}
